import React from "react";
import trans from "trans";

import { Spinner, css,
} from "@bdfx/mergado-ui-kit"

export const SettingsSpinner = () => (
    <StyledSettingsSpinner>
        <Spinner type={"bubbles"}/><br/>
        {trans("loading")}
    </StyledSettingsSpinner>
)

export const StyledSettingsSpinner = css('div')({
    textAlign: "center",
    display: "block",
    minHeight: '100px',
    paddingTop: '40px 0',
})